import Vue from "vue";
import Vuex from "vuex";

import $_InsightFactory from "./$_InsightFactory.store";
import $_User from "./$_User.store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    $_InsightFactory,
    $_User,
  },
});
